<template>
  <div class="detail_wrapper full-height" v-loading.fullscreen.lock="globalLoading">
    <transition name="fade-transform" mode="out-in">
      <div class="detail" v-if="pageType === 'DETAIL'">
        <div class="detail-log_menu">
          <h3 class="detail-log_menu-title">日志库</h3>
          <div class="detail-log_menu-search">
            <el-input
              class="log-search-int"
              v-model="logSearchName"
              placeholder="请输入关键字"
              @keyup.enter.native="onSearch"
            >
              <i class="el-icon-search el-input__icon" slot="suffix" @click="onSearch"></i>
            </el-input>
            <el-button class="detail-log_menu-search-btn" type="primary" @click="onCreateLog"
              >创建</el-button
            >
          </div>

          <div class="detail-log-list" v-loading="loading">
            <el-collapse
              class="collapse_no_bottom"
              v-model="activeLog"
              v-if="logList && logList.length > 0"
              accordion
              @change="handleLogChange"
            >
              <el-collapse-item
                class="detail-log-list-item custom-collapse-item-hide-arrow"
                v-for="log in logList"
                :key="log.id"
                :title="log.name"
                :name="log.id"
              >
                <template #title>
                  <div class="detail-log-list-title" :title="log.name">
                    <i class="el-icon-caret-right"></i>
                    <div class="detail-log-list-title-inner" @click.stop="onLogClick(log)">
                      <img
                        class="detail-log-list-title-icon"
                        src="../../../assets/icon/folder.png"
                      />
                      <span class="list-title-inner-text ellipsis">{{ log.name }}</span>
                    </div>
                  </div>
                </template>
                <div class="log-icon-wrapper">
                  <img
                    class="log-icon-wrapper-item"
                    v-for="logIcon in logIconArr"
                    :key="logIcon.name"
                    :src="require(`@/assets/icon/${logIcon.name}${logIcon.activePath}.png`)"
                    :title="logIcon.label"
                    :alt="logIcon.label"
                    @click="onClickLogIcon(logIcon.name, log)"
                    @mouseenter="onMouseEnter(logIcon)"
                    @mouseleave="onMouseLeave(logIcon)"
                  />
                </div>
                <el-tree
                  class="tree"
                  node-key="id"
                  ref="tree"
                  :data="log.logTreeData"
                  :props="{ label: 'name', isLeaf: 'isLeaf', children: 'children' }"
                  @node-click="handleTreeClick"
                >
                  <template #default="{ data }">
                    <p class="ellipsis tree-name" :title="data.name">{{ data.name }}</p>
                  </template>
                </el-tree>
              </el-collapse-item>
            </el-collapse>
            <div class="detail-log-empty" v-else>暂无数据</div>
          </div>
        </div>
        <div class="detail-log-content log-description-content" v-loading="detailLoading">
          <el-tabs class="el-tabs" v-model="activeTab" @tab-remove="handleRemoveTab">
            <el-tab-pane class="detail-log-content-tab" label="详情" name="detail">
              <div class="detail-log-content-info">
                <base-card ref="baseCard" title="基础信息">
                  <base-card-item label="项目名称：">
                    <p class="base-card-list-item-value">{{ projectInfo.name }}</p>
                  </base-card-item>
                  <base-card-item label="创建时间：">
                    <p class="base-card-list-item-value">{{ projectInfo.gmtCreate }}</p>
                  </base-card-item>
                  <base-card-item label="区域：">
                    <p class="base-card-list-item-value">{{ projectInfo.regionId }}</p>
                  </base-card-item>
                  <base-card-item label="UUID：">
                    <p class="base-card-list-item-value">{{ projectInfo.projectId }}</p>
                  </base-card-item>
                  <base-card-item label="描述：">
                    <p class="base-card-list-item-value">{{ projectInfo.description }}</p>
                  </base-card-item>
                </base-card>
              </div>
              <div class="detail-log-content-tab-footer">
                <el-button type="primary" @click="onShowLogType">接入数据</el-button>
              </div>
            </el-tab-pane>
            <el-tab-pane
              closable
              :key="detail.id"
              v-for="detail in detailTabs"
              :label="detail.name"
              :name="detail.id"
            >
              <iframe
                v-if="detail.type === 'LOG'"
                class="detail-log-content-kibana"
                :src="getRealKibanaUrl(detail.showUrl)"
              ></iframe>
              <div class="detail-log-content-view" v-if="detail.type === 'RULE'">
                <div class="detail-log-content-view-item detail-log-content-view-rule">
                  <h3 class="detail-log-content-view-title">规则详情</h3>
                  <access-config-creator
                    v-if="detail.ruleData.id"
                    ref="accessConfigCreator"
                    :ruleData="detail.ruleData"
                    formType="SHOW"
                  ></access-config-creator>
                </div>
                <div class="detail-log-content-view-item detail-log-content-view-guide">
                  <h3 class="detail-log-content-view-title">接入指南说明</h3>
                  <log-access-guide-viewer
                    v-if="detail.ruleData.id"
                    ref="logAccessGuideViewer"
                    :dataSourceConfigData="detail.dataSourceConfigData"
                  ></log-access-guide-viewer>
                </div>
              </div>
              <alarm-index
                v-if="detail.type === 'WARN'"
                ref="alarmIndex"
                :logId="alarmData.alarmLogId"
                :logName="alarmData.alarmLogName"
                :storeDbName="alarmData.storeDbName"
                :projectId="projectInfo.projectId"
              ></alarm-index>
              <div class="detail-log-content-empty" v-else>
                <p class="text">暂无网络，请检查网络连接</p>
                <img src="../../../assets/img/no-newwork.png" />
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>
        <log-creator-and-editor
          ref="logCreatorAndEditor"
          @submit="handleLogCreated"
        ></log-creator-and-editor>

        <log-type-selector
          ref="logTypeSelector"
          @clickDetail="handleDetailAccess"
        ></log-type-selector>
      </div>

      <router-view v-if="pageType === 'ACCESS'"></router-view>
    </transition>
  </div>
</template>

<script>
import { reqShowProject } from '../../../api/project';
import {
  reqFetchLogs,
  reqShowLog,
  reqDestroyLog,
  reqFetchKibanaUserInfo,
  reqFetchParseRules,
  reqShowRuleDetail
} from '../../../api/log';
import LogCreatorAndEditor from '../common/LogCreatorAndEditor';
import LogTypeSelector from '../common/LogTypeSelector';
import BaseCard from '../../common/BaseCard';
import BaseCardItem from '../../common/BaseCardItem';
import AccessConfigCreator from '../common/access-rule/AccessConfigCreator';
import LogAccessGuideViewer from '../common/LogAccessGuideViewer';
import AlarmIndex from '../alarm/AlarmIndex';

export default {
  name: 'Detail',

  components: {
    LogCreatorAndEditor,
    LogTypeSelector,
    BaseCard,
    BaseCardItem,
    AccessConfigCreator,
    LogAccessGuideViewer,
    AlarmIndex
  },

  data() {
    return {
      pageType: 'DETAIL',
      loading: false,
      detailLoading: false,
      globalLoading: false,
      alarmPageVisible: true,
      projectInfo: {
        name: '',
        gmtCreate: '',
        regionId: '',
        projectId: '',
        description: ''
      },
      logSearchName: '',
      activeLog: '',
      activeTab: 'detail',
      logListOrigin: [], // 记录全部 log 数据
      logList: [],
      detailTabs: [],
      kibanaUserInfo: {
        username: '',
        password: ''
      },
      alarmData: {
        alarmLogId: '',
        alarmLogName: '',
        storeDbName: '',
        projectId: ''
      },
      accessLogId: null, // 详情页日志库列表点击接入数据，需要记录 logId
      activeTreeIndex: 0, // 记录刚刚打开的 tree 下标 ，关闭时初始化 tree
      isActive: false,
      logIconArr: [
        {
          name: 'view',
          label: '查看',
          activePath: ''
        },
        {
          name: 'access',
          label: '接入数据',
          activePath: ''
        },
        {
          name: 'edit',
          label: '编辑',
          activePath: ''
        },
        {
          name: 'delete',
          label: '删除',
          activePath: ''
        }
      ]
    };
  },

  watch: {
    /**
     * 保证从面包屑回到该页面时能复位
     */
    $route: {
      immediate: true,
      deep: true,
      handler(to, from) {
        if (!from) {
          this.pageType = to.name === 'ProjectsDetailAccess' ? 'ACCESS' : 'DETAIL';
        } else {
          this.pageType = from.name === 'ProjectsDetailAccess' ? 'DETAIL' : 'ACCESS';
        }

        if (this.pageType === 'DETAIL') {
          this.getLogList();
          this.getProjectDetail();
          // this.getKibanaUserInfo();

          // 存在 logId 即接入数据后点击查看日志
          this.detailTabs = [];
          if (sessionStorage.getItem('logInfo')) {
            this.onLogClick(JSON.parse(sessionStorage.getItem('logInfo')));
            sessionStorage.removeItem('logInfo');
          } else {
            // 其他情况，数据初始化
            this.activeTab = 'detail';
          }
        }
      }
    }
  },

  methods: {
    /**
     * 获取日志列表
     */
    async getLogList() {
      try {
        this.loading = true;
        const { data } = await reqFetchLogs({ projectId: this.$route.params.projectId });
        // 冻结原始数据
        this.logListOrigin = Object.freeze(data);
        // 添加树结构数据
        this.logList = data.map(log => {
          log.logTreeData = [
            {
              isMenu: true,
              type: 'RULE',
              name: '日志规则查询',
              id: 'rule_menu', // 加 id 才可以折叠树节点
              children: []
            },
            {
              isMenu: false,
              type: 'WARN',
              name: '日志告警',
              id: 'alarm_warn',
              logId: log.id,
              storeDbName: log.storeDbName,
              alarmLogName: log.name
            }
          ];
          log.loaded = false;
          return log;
        });

        // 日志库列表折叠面板初始化
        this.activeLog = '';
      } finally {
        this.loading = false;
      }
    },
    onMouseEnter(logIcon) {
      logIcon.activePath = '-active';
    },
    onMouseLeave(logIcon) {
      logIcon.activePath = '';
    },
    /**
     * 加载日志规则列表
     */
    async handleLogChange(logId) {
      if (!logId) {
        return;
      }

      // 折叠所有树节点
      Object.values(this.$refs.tree[this.activeTreeIndex].store.nodesMap).forEach(node => {
        node.expanded = false;
      });

      // 取消高亮
      this.$refs.tree[this.activeTreeIndex].setCurrentKey(null);

      try {
        this.activeTreeIndex = this.logList.findIndex(log => log.id === logId);
        const activeTreeNode = this.logList[this.activeTreeIndex];

        // 如果加载过，则不再请求数据
        if (activeTreeNode.loaded) {
          return;
        }

        this.loading = true;
        // @TODO 添加 setTimeout 为了解决第一次展开 el-collapse 没有动画问题，后续再调研最优方案。
        setTimeout(async () => {
          const { data } = await reqFetchParseRules({ logId: logId });
          data.forEach(rule => {
            rule.type = 'RULE';
          });
          activeTreeNode.logTreeData[0].children = data;
          activeTreeNode.loaded = true;
        }, 0);
      } finally {
        this.loading = false;
      }
    },
    /**
     * 显示规则或告警
     */
    async handleTreeClick(data) {
      // 如果是菜单不进行操作
      if (data.isMenu) {
        return;
      }

      this.alarmData.alarmLogId = data.logId;
      this.alarmData.alarmLogName = data.alarmLogName;
      this.alarmData.storeDbName = data.storeDbName;

      // 如果是告警，则进行告警操作
      if (data.type === 'WARN') {
        this.alarmData.projectId = this.$route.params.projectId;

        // 如果添加过告警，判断是不是属于同一个日志库
        if (this.onCheckRepeat(data)) {
          const tabIndex = this.detailTabs.findIndex(tab => data.id === tab.id);
          const tempWarn = this.detailTabs[tabIndex];
          this.activeTab = data.id;

          // 如果告警 id 相同，logId 也相同，说明是同一个告警，不做操作
          if (tempWarn.logId === data.logId) {
            return;
          }
          // 否则，更新数据
          this.detailTabs[tabIndex] = data;
          return;
        }

        // 如果没有添加过告警，直接 push
        this.detailTabs.push(data);
        this.activeTab = data.id;
      }

      if (data.type === 'RULE') {
        if (this.onCheckRepeat(data)) {
          // tab 列表中有数据时，直接切换 tab
          this.activeTab = data.id;
          return;
        }
        this.onShowRuleDetail(data);
      }

      this.activeTab = data.id;
      this.$bus.$emit('bus_toggleMenuCollapse', true);
    },
    /**
     * 加载规则和接入指南详情
     */
    async onShowRuleDetail(rule) {
      try {
        this.detailLoading = true;
        const { data } = await reqShowRuleDetail({
          ruleId: rule.id
        });

        rule.ruleData = data.parseRuleDto;
        rule.dataSourceConfigData = data.mdStr;

        this.detailTabs.push(rule);
        this.activeTab = rule.id;
      } finally {
        this.detailLoading = false;
      }
    },
    /**
     * 获取项目详情
     */
    async getProjectDetail() {
      try {
        this.detailLoading = true;

        const { data } = await reqShowProject(this.$route.params.projectId);

        this.projectInfo = {
          name: data.name,
          gmtCreate: data.gmtCreate,
          regionId: data.regionId,
          projectId: data.id,
          description: data.description
        };
      } finally {
        this.detailLoading = false;
      }
    },
    async getKibanaUserInfo() {
      const { data } = await reqFetchKibanaUserInfo();
      this.kibanaUserInfo = {
        username: data.userName,
        password: data.password
      };
    },
    getRealKibanaUrl(showUrl) {
      return `${showUrl}&userId=${this.$store.getters['user/userId']}`;
    },
    /**
     * 日志搜索（前端做筛选）
     */
    onSearch() {
      this.logList = this.logSearchName
        ? this.logListOrigin.filter(item => {
            const tempName = new RegExp(this.logSearchName, 'g');
            return tempName.exec(item.name);
          })
        : this.logListOrigin;
    },
    /**
     * 创建日志库
     */
    onCreateLog() {
      this.$refs.logCreatorAndEditor.open({
        drawerType: 'create',
        projectId: this.$route.params.projectId
      });
    },
    /**
     * 编辑日志库
     */
    onEditLog(logId) {
      this.$refs.logCreatorAndEditor.open({
        drawerType: 'edit',
        logId: logId,
        projectId: this.$route.params.projectId
      });
    },
    /**
     * 删除日志库
     */
    async onDeleteLog(log) {
      try {
        await this.$msgbox({
          title: `警告`,
          message: `确定要删除日志库【${log.name}】吗？`,
          type: 'warning',
          showCancelButton: true,
          beforeClose: async (action, instance, done) => {
            if (action === 'cancel') {
              done();
              return;
            }

            this.globalLoading = true;

            await reqDestroyLog({
              logId: log.id
            });

            if (this.detailTabs.length > 0) {
              // 删除时 tab 中移除该打开的日志库
              const isExistLog = this.detailTabs.some(item => item.id === log.id);

              if (isExistLog) {
                this.handleRemoveTab(log.id);
              }

              // 删除时 tab 中移除该日志库下打开的日志规则
              if (log.logTreeData[0].children.length > 0) {
                log.logTreeData[0].children.forEach(tab => {
                  const isExistRule = this.detailTabs.some(item => item.id === tab.id);

                  if (isExistRule) {
                    this.handleRemoveTab(tab.id);
                  }
                });
              }

              // 删除时 tab 中移该日志库下打开的告警
              const isExistWarn = this.detailTabs.some(
                item => item.logId === log.logTreeData[1].logId
              );
              if (isExistWarn) {
                this.handleRemoveTab(log.logTreeData[1].id);
              }
            }

            this.$message.success('删除成功');
            this.getLogList();

            done();
          }
        });
      } catch (e) {
        if (e === 'cancel') return;
      } finally {
        this.globalLoading = false;
      }
    },
    /**
     * 日志库创建成功后的回调
     */
    handleLogCreated(drawerType, name, data) {
      // 创建成功后，询问是否接入数据
      drawerType === 'edit'
        ? this.$message.success('保存成功')
        : this.$confirm(`日志库: ${name} 创建成功! 是否立即接入数据？`, '提示', {
            confirmButtonText: '接入数据',
            cancelButtonText: '取消',
            type: 'success'
          })
            .then(() => {
              this.onShowLogType(data);
            })
            .catch(() => {});
      this.getLogList();
    },
    /**
     * 检查是否重复
     */
    onCheckRepeat(data) {
      return this.detailTabs.some(detailTab => detailTab.id === data.id);
    },
    /**
     * 判断浏览器是否是 Edge 和 IE
     */
    getBroswerName() {
      const ua = navigator.userAgent.toLowerCase();
      return [/edge\/([\d.]+)/, /rv:([\d.]+)\) like gecko/].some(broswer => ua.match(broswer));
    },
    /**
     * 点击日志列表操作按钮
     */
    onClickLogIcon(name, log) {
      if (name === 'view') {
        this.onLogClick(log);
      }
      if (name === 'access') {
        this.onShowLogType(log);
      }
      if (name === 'edit') {
        this.onEditLog(log.id);
      }
      if (name === 'delete') {
        this.onDeleteLog(log);
      }
    },
    /**
     * 查看日志库 kibana
     */
    async onLogClick(log) {
      // if (!(this.kibanaUserInfo.username && this.kibanaUserInfo.password)) {
      //   try {
      //     this.detailLoading = true;
      //     await this.getKibanaUserInfo();
      //   } catch {
      //     this.$message.error('日志分析平台初始化失败，请尝试刷新页面后重试');
      //     return;
      //   } finally {
      //     this.detailLoading = false;
      //   }
      // }
      if (this.getBroswerName()) {
        this.$message.warning(
          '建议使用 Chrome 和 Firefox 浏览器进行浏览，否则可能不会获得最佳体验'
        );
      }

      try {
        const { data } = await reqShowLog(log.id);
        data.type = 'LOG';
        this.detailLoading = true;
        this.activeTab = data.id;

        if (this.onCheckRepeat(data)) {
          return;
        }

        this.detailTabs.push(data);

        this.$bus.$emit('bus_toggleMenuCollapse', true);
      } finally {
        this.detailLoading = false;
      }
    },
    /**
     * 移除 tab
     */
    handleRemoveTab(tabId) {
      let tabs = this.detailTabs;

      if (this.activeTab === tabId) {
        tabs.forEach((tab, index) => {
          if (tab.id === tabId) {
            let nextTab = tabs[index + 1] || tabs[index - 1];
            if (nextTab) {
              this.activeTab = nextTab.id;
            } else {
              this.activeTab = 'detail';
            }
          }
        });
      }

      this.detailTabs = tabs.filter(tab => tab.id !== tabId);
    },
    /**
     * 接入数据，显示日志类型
     */
    onShowLogType(log) {
      try {
        this.accessLogId = log.id;
      } catch (e) {
        this.accessLogId = null;
      } finally {
        this.$refs.logTypeSelector.open();
      }
    },
    /**
     * 跳转到接入数据页
     */
    handleDetailAccess() {
      this.pageType = 'ACCESS';
      this.$router.push({
        name: 'ProjectsDetailAccess',
        params: this.$route.params,
        query: this.accessLogId ? { logId: this.accessLogId } : null
      });
    }
  }
};
</script>

<style lang="scss" scoped>
$tree-node-height: 40px;

p {
  margin: 0;
}

h3 {
  margin: 0;
  font-weight: normal;
}
.detail {
  display: flex;
  padding: 20px;
  height: 100%;
  box-sizing: border-box;

  ul {
    list-style: none;
    padding: 0;
    margin: 0;
  }

  &-log_menu {
    display: flex;
    flex-direction: column;
    flex-shrink: 0;
    width: 17%;
    max-width: 340px;
    min-width: 180px;
    padding-right: 20px;
    margin-right: 20px;
    border-right: 2px solid #f1f1f1;

    &-title {
      margin-bottom: 20px;
      font-size: 14px;
      color: #333;
    }

    &-search {
      display: flex;
      justify-content: space-between;

      .el-icon-search {
        cursor: pointer;
      }

      .log-search-int {
        width: 220px;
      }

      &-btn {
        margin-left: 10px;
      }
    }
  }

  .detail-log-list {
    height: 100%;
    margin-top: 20px;
    margin-right: 10px;
    overflow: auto;

    &-item {
      font-size: 14px;

      .log-icon-wrapper {
        display: flex;
        justify-content: space-between;
        margin: 10px 0;
        padding: 0 17px;
        cursor: pointer;

        &-item {
          display: inline-block;
          width: 16px;
          height: 16px;
          transition: 0.3s;
        }
      }
    }

    &-title {
      width: 100%;
      display: flex;
      align-items: center;
      padding-left: 14px;
      font-size: 14px;

      &-inner {
        height: 100%;
        width: calc(100% - 14px);
        display: flex;
        align-items: center;
        padding-right: 14px;

        .list-title-inner-text {
          display: block;
        }
      }

      &-icon {
        width: 16px;
        margin: 0 10px;
      }

      .el-icon-caret-right {
        color: #848b8f;
      }
    }

    .tree {
      &-name {
        font-size: 14px;
      }
    }
  }

  &-log-empty {
    height: 100%;
    flex: auto;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #999;
  }

  &-log-content {
    flex: auto;
    min-width: 500px;

    // tab高度占满屏
    .el-tabs {
      display: flex;
      flex-direction: column;
    }

    /deep/ .el-tabs__header {
      margin-bottom: 0;
    }

    /deep/ .el-tabs__content {
      flex: auto;
    }

    &-info {
      margin-top: 15px;
    }

    .el-tab-pane {
      height: 100%;
    }

    .detail-log-content-tab {
      display: flex;
      flex-direction: column;
      justify-content: space-between;

      &-footer {
        margin: 30px 0;
        text-align: center;
      }
    }

    &-info {
      flex: auto;
      margin-top: 20px;
      overflow: auto;
    }

    &-kibana {
      width: 100%;
      height: 100%;
      box-sizing: border-box;
      border: 0;
    }

    &-view {
      display: flex;
      height: 100%;
      padding-top: 40px;

      &-item {
        flex: 1;
        padding: 20px;
        border: 1px solid #f2f4f8;
      }

      &-rule {
        height: 100%;
        margin-right: 20px;
        overflow: auto;
      }

      &-guide {
        height: 100%;
        overflow: auto;

        /deep/ h2 {
          margin: 18px 0 20px 0;
          line-height: 1;
          font-size: 12px;
        }

        /deep/ p {
          margin: 19px 0 10px;
          font-size: 12px;
          color: #555;
        }
      }

      &-title {
        margin-bottom: 10px;
        font-size: 14px;
        font-weight: bold;
      }
    }

    &-empty {
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;

      .text {
        margin-bottom: 40px;
        font-size: 18px;
        color: #999;
      }
    }

    .el-tabs {
      height: 100%;
    }

    /deep/ .el-tabs__nav-wrap::after {
      background: #f1f1f1;
    }
  }

  /deep/ .access-config {
    &-form {
      width: 82%;
    }
  }
}

.ellipsis {
  width: 100%;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

/deep/ .el-collapse-item__header {
  .el-icon-caret-right {
    transition: all 0.16s ease-in-out;
  }

  &.is-active {
    .el-icon-caret-right {
      transform: rotate(90deg);
    }
  }
}

.custom-collapse-item-hide-arrow {
  /deep/ .el-collapse-item__arrow {
    display: none !important;
  }
}

// tree 样式调整
/deep/ .el-collapse {
  border: 0;

  .el-collapse-item__header {
    height: $tree-node-height;
    background-color: #e9f7ff;
    border: 0;
  }

  .el-tree-node__content {
    overflow: hidden;
    height: $tree-node-height;
    color: #333;
  }

  .el-tree-node__content:hover {
    background-color: #f2f3f6;
  }

  .el-tree-node__expand-icon {
    margin-left: 14px;
    color: #848b8f;
  }

  .el-tree-node.is-current {
    & > .el-tree-node__content {
      transition: all 0.16s ease-in-out;
      background-color: $g-color-primary;
      color: #fff !important;

      .el-tree-node__expand-icon {
        color: #fff;
      }

      .tree_node {
        .right {
          &-field {
            color: #fff !important;
          }

          &-dropdown {
            &-trigger {
              color: #fff !important;
            }
          }
        }
      }
    }
  }

  .el-tree-node__expand-icon.is-leaf {
    color: transparent !important;
  }
}

// 取消 el-collapse-item 底部的空白区域
/deep/ .collapse_no_bottom {
  .el-collapse-item__content {
    padding-bottom: 0;
  }
}
</style>
